var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('temp',{ref:"temp",attrs:{"type":"school","data":_vm.sourceData,"zhilian":_vm.$env.link.agency.zhilian,"job51":_vm.$env.link.agency.job51}})}
var staticRenderFns = []

export { render, staticRenderFns }